//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayJs from 'dayjs'
import get from 'lodash/get'
import debounce from 'lodash/debounce'
import readingTime from 'reading-time'
import { generateImageURL, generateUrlPath } from '~/utils/storage'
import hasWindow from '~/mixins/hasWindow'
import canShare from '~/mixins/canShare'
import hasArticles from '~/mixins/hasArticles'
import Article from '~/models/Article'
import Comment from '~/components/article/article-detail/Comment.vue'

export default {
  components: { Comment },
  mixins: [hasArticles, hasWindow, canShare],

  props: { article: { type: Object, default: () => ({}) } },

  data() {
    return {
      visible: false,
    }
  },

  mounted() {
    this.maybeMarkAsReadDebounced = debounce(this.maybeMarkAsRead, 200)
    addEventListener('scroll', this.maybeMarkAsReadDebounced)
  },

  beforeDestroy() {
    removeEventListener('scroll', this.maybeMarkAsReadDebounced)
  },

  methods: {
    get,
    generateUrlPath,
    getDate(date) {
      return dayJs(date).format('DD MMM YYYY')
    },
    generateImage(url) {
      return `${generateImageURL(url || '')}?&fit=crop`
    },
    maybeMarkAsRead() {
      if (this.article.user_point || !this.$auth.isLoggedIn) return

      const articleBottom = this.$el.getBoundingClientRect().bottom

      if (articleBottom <= innerHeight) {
        this.markAsRead()
      }
    },

    async markAsRead() {
      try {
        const response = await this.$axios.post(
          `v1/articles/${this.article.id}/read`
        )
        const article = new Article(response.data.data)

        this.updateArticle(article)
      } catch (error) {
        // console.error(error)
      }
    },
    async markAsShare(type) {
      try {
        await this.$axios.post(`v1/articles/${this.article.id}/share`, {
          provider: type,
        })
      } catch (error) {
        // console.error(error)
      }
    },
    goBack() {
      this.$router.back()
    },
    handleShare(type) {
      if (type === 'facebook') {
        this.shareFacebook(location.href)
      } else if (type === 'twitter') {
        this.shareTwitter(location.href)
      } else if (type === 'whatsapp') {
        this.shareWhatsApp(location.href)
      }

      if (this.$auth.isLoggedIn) {
        this.markAsShare(type)
      }
    },
    getReadingTime(content) {
      return readingTime(content).text
    },
    async shareCopy(URL, text) {
      await navigator.clipboard.writeText(`${location.href}`)

      if (this.$auth.isLoggedIn) {
        this.markAsShare('copy_link')
      }
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true
      } else {
        return false
      }
    },
    handleScroll(event) {
      window.onscroll = function () {
        const top = window.pageYOffset || document.documentElement.scrollTop
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
        } else {
          if (top > 450) {
            document.getElementById('categoryWrapper').style.position = 'fixed'
            document.getElementById('categoryWrapper').style.top = '10px'
          } else {
            document.getElementById('categoryWrapper').style.position = 'unset'
            document.getElementById('categoryWrapper').style.top = '0'
            document.getElementById('categoryWrapper').style.bottom = 'unset'
            document.getElementById('categoryWrapper').style.transition =
              'all 0.5s ease-in-out'
          }

          if (
            window.innerHeight + window.scrollY >=
            document.body.offsetHeight - 250
          ) {
            document.getElementById('mainWrapper').style.position = 'relative'
            document.getElementById('categoryWrapper').style.position =
              'absolute'
            document.getElementById('categoryWrapper').style.top = 'unset'
            document.getElementById('categoryWrapper').style.bottom = '0'
          }
        }
      }
    },
  },

  head() {
    return {
      title: this.article.title ? this.article.title : "Charm Girl's Talk",
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.article.description ? this.article.description : '',
        },
        {
          property: 'og:title',
          content: this.article.title
            ? this.article.title
            : "Charm Girl's Talk",
        },
        { property: 'og:image', content: this.article.imageURL },
      ],
    }
  },
}
